module.exports = __webpack_public_path__ + "img/app_center.e34c3c71.svg";